"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _field = _interopRequireDefault(require("./field"));

var _ui = require("../../../constants/ui.messages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var REGEX_EXPRESSION = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

var EmailField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmailField, _React$Component);

  function EmailField(props) {
    var _this;

    _classCallCheck(this, EmailField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmailField).call(this, props));
    _this.state = {
      isFormatValid: undefined
    };
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EmailField, [{
    key: "validate",
    value: function validate(value) {
      var isFormatValid = value ? REGEX_EXPRESSION.test(value) : true;
      this.setState({
        isFormatValid: isFormatValid
      });
      return isFormatValid && this.props.onValidate(value);
    }
  }, {
    key: "render",
    value: function render() {
      var validationMessage = this.state.isFormatValid ? this.props.validationMessages.custom : this.props.validationMessages.invalid || _ui.INVALID_EMAIL_FORMAT_FEEDBACK;
      return _react.default.createElement(_field.default, _extends({}, this.props, {
        validationMessages: _objectSpread({}, this.props.validationMessages, {
          custom: validationMessage
        }),
        onValidate: this.validate
      }), this.props.children);
    }
  }]);

  return EmailField;
}(_react.default.Component);

EmailField.propTypes = _objectSpread({}, _field.default.propTypes, {
  children: function children(props, propName, componentName) {
    if (!/^email$/.test(props[propName].props.type)) {
      throw Error('Invalid children. Only inputs of type email are valid.');
    }
  },

  /** {object} Object with shape {required: string, invalid: string, custom: string}. Values are the messages to be displayed after required, invalid email and custom validations fail. */
  validationMessages: (0, _propTypes.shape)({
    required: _propTypes.string,
    invalid: _propTypes.string,
    custom: _propTypes.string
  })
});

var noop = function noop() {
  return true;
};

EmailField.defaultProps = _objectSpread({}, _field.default.defaultProps, {
  onValidationChange: noop
});
var _default = EmailField;
exports.default = _default;
EmailField.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "validate",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "EmailField",
  "props": {
    "onValidationChange": {
      "defaultValue": {
        "value": "() => true",
        "computed": false
      },
      "required": false
    },
    "children": {
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (!/^email$/.test(props[propName].props.type)) {\n    throw Error('Invalid children. Only inputs of type email are valid.')\n  }\n}"
      },
      "required": false,
      "description": ""
    },
    "validationMessages": {
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "string",
            "required": false
          },
          "invalid": {
            "name": "string",
            "required": false
          },
          "custom": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "{object} Object with shape {required: string, invalid: string, custom: string}. Values are the messages to be displayed after required, invalid email and custom validations fail."
    }
  },
  "composes": ["./field"]
};